import React, { useState, useRef } from "react";
import { noop } from "@client/shared/constants";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

const defaultState = {
  open: false,
};

const Dropdown = ({
  options = [],
  customToggle = null,
  classes = {},
  transformOrigin = { horizontal: "right", vertical: "top"  },
  anchorOrigin = { horizontal: "right", vertical: "top" },
  onChange = noop
}) => {
  const [state, setState] = useState(defaultState);
  const anchorEl = useRef(null);

  const handleOpen = () => {
    setState((prevState) => ({
      ...prevState,
      open: !prevState.open,
    }));
  };

  const handleSelection = (callback = noop, option) => {
    setState((prevState) => ({
      ...prevState,
      open: false,
    }));
    callback();
    onChange(option);
  };

  return (
    <>
      <Box ref={anchorEl} onClick={handleOpen}>
        {customToggle ? (
          customToggle
        ) : (
          <IconButton>
            <MoreVertIcon fontSize="large" sx={classes.moreIcon} />
          </IconButton>
        )}
      </Box>
      <Menu
        disablePortal
        anchorEl={anchorEl.current}
        open={state.open}
        onClose={handleOpen}
        transformOrigin={transformOrigin}
        anchorOrigin={anchorOrigin}
        sx={classes.list}
      >
        {options.map((option) => (
          <MenuItem onClick={() => handleSelection(option.onClick, option)}>
            {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Dropdown;
